// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.ferm_line_drive_enum */
var FermLineDriveEnum;
(function (FermLineDriveEnum) {
    FermLineDriveEnum["RATE"] = "RATE";
    FermLineDriveEnum["PULSE"] = "PULSE";
    FermLineDriveEnum["PH_STAT"] = "PH_STAT";
    FermLineDriveEnum["DO_STAT"] = "DO_STAT";
})(FermLineDriveEnum || (FermLineDriveEnum = {}));
;
export default FermLineDriveEnum;
/** Zod schema for ferm_line_drive_enum */
export const fermLineDriveEnum = z.nativeEnum(FermLineDriveEnum);
//# sourceMappingURL=FermLineDriveEnum.js.map